import React from 'react'
import styled from '@emotion/styled'

import { useTheme } from '@emotion/react'

import { FlexibleScheduleIcon, EngagingIcon, ToolIcon } from '@segment/matcha/components/Icons/Brandbook'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import IconWrapper from '@segment/matcha/components/IconWrapper'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const featured = [
  {
    key: `best-tools`,
    title: `Implement new tools, fast`,
    description: `Integrate new tools in minutes, not weeks. No more setup headaches and no need to push code.`,
    icon: <ToolIcon />,
  },
  {
    key: `same-data-all-tools`,
    title: `Mobile approvals, instantly`,
    description: `Eliminate the wait for App Store approvals. Activate new tools immediately, including those without their own mobile SDKs.`,
    icon: <EngagingIcon />,
  },
  {
    key: `focus-on-product`,
    title: `Focus on product work, now`,
    description: `Segment makes trying new tools incredibly easy. Say goodbye to expensive and time-consuming integration processes that stand in the way of leveraging the best tools available.`,
    icon: <FlexibleScheduleIcon />,
  },
]

const FeatureBoxGroup = () => {
  const theme = useTheme()
  return (
    <SectionBaseWrapper variant="centered">
      <Section.Contents>
        <StyledColumnTrack columns={1} overrides={{ lg: 3 }}>
          {featured.map((feature) => (
            <StyledFeatureBoxBase alignment="left" headerPosition="top" key={feature.key}>
              <FeatureBox.Header>
                <IconWrapper
                  tokens={{ color: theme.palette.twilio.gray[100] }}
                  background="white"
                  elevation={1}
                  variant="circle"
                >
                  {feature.icon}
                </IconWrapper>
              </FeatureBox.Header>
              <FeatureBox.Body>
                <FeatureBox.Title>{feature.title}</FeatureBox.Title>
                <FeatureBox.Text>{feature.description}</FeatureBox.Text>
              </FeatureBox.Body>
            </StyledFeatureBoxBase>
          ))}
        </StyledColumnTrack>
      </Section.Contents>
    </SectionBaseWrapper>
  )
}

const StyledColumnTrack = styled(ColumnTrack)`
  max-width: 1064px;
  margin: 0 auto;
`

const SectionBaseWrapper = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 0;
    padding-top: 40px;
    padding-bottom: 80px;
  }
`

const StyledFeatureBoxBase = styled(FeatureBoxBase)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    padding: 24px;
  }
`

export default FeatureBoxGroup
